/* =========================================================================
 * POSŒNNOÏSME — Pratiques (Shopify / Custom Liquid)
 * Single-file runtime (DATA FR + CSS + rendering + behaviors)
 * File: po-posoenno-pratiques-fr-20260222.js
 * ========================================================================= */
(function () {
  'use strict';

  /* -----------------------------
   * 0) CONFIG
   * ----------------------------- */
  var lang = (window.PO_PAGE_LANG || document.documentElement.lang || 'fr').toLowerCase();
  if (lang !== 'fr') lang = 'fr'; // FR only pour l’instant

  var mountSelector = window.PO_MOUNT_SELECTOR || '#po-pratiques-mount';
  var FORCE_RESEARCH = !!window.PO_RESEARCH_MODE;

  var LS_KEY = 'po_pratiques_research_mode';

  /* -----------------------------
   * 1) DATA (FR)
   * ----------------------------- */
  var DATA = {
    page: {
      eyebrow: 'PARCOURS CURIEUX & CHERCHEUR',
      h1: 'Pratiques',
      lede:
        "Le Posœnnoïsme se lit et se traverse — puis il s’incarne. Les Méditations et les Accords proposés ici constituent des voies de tenue : réglage intérieur et syntonie relationnelle.",
      ctaResearch: 'Chercheur',
      ctaResearchHint: "Déploie les paramètres opératifs, la lecture par Sceaux, et les correspondances modélisées.",
    },

    meditationsTitleEyebrow: 'PRATIQUES CONTEMPLATIVES',
    meditationsTitle: 'Méditations',

    accordsTitleEyebrow: 'FORMULATIONS CONTEMPLATIVES',
    accordsTitle: 'Accords',
    accordsIntro:
      "Les Accords sont des formulations courtes à dire, écrire ou méditer. Ils ne visent pas l’optimisme : ils ancrent dans la réalité telle qu’elle se présente.",

    meditations: [
      {
        id: 'med_dt_minimal',
        title: 'Méditation du Δτ minimal',
        subtitle: 'Ressentir l’interstice',
        duration: '15 min',
        level: 'Initiation',
        desc:
          "Cette pratique ouvre à la perception de l’intervalle entre deux phénomènes. Le Δτ minimal correspond au seuil où la densité du réel se condense avant toute projection. Il s’agit d’habiter l’interstice, sans volonté d’interprétation.",
        protocolTitle: 'Protocole',
        protocol: [
          'Posture stable, regard détendu.',
          'Observation de la respiration naturelle.',
          "Attention portée à l’espace entre expiration et inspiration.",
          'Question silencieuse : « Qu’est-ce qui demeure ici ? »',
          'Suspension de toute réponse mentale.',
        ],
        research: {
          epsilon: 'ε faible (indication : 0,1–0,2)',
          canaux: 'Un canal dominant (réglage interne), réversibilité élevée.',
          visee: 'Stabilisation du seuil, réduction du bruit, tenue du présent.',
          modalites: ['Temporalité', 'Conscience', 'Lucidité'],
          trace: "Perception nette d’un interstice habitable ; pensée moins pressée.",
        },
      },
      {
        id: 'med_isqun',
        title: "Méditation de l’Isqun",
        subtitle: 'Atteindre la coïncidence',
        duration: '30 min',
        level: 'Intermédiaire',
        desc:
          "L’Isqun agit comme régulateur multi-polaire. Cette méditation travaille la redistribution interne des tensions : percevoir les points de déséquilibre et les ramener vers une équiphase intérieure.",
        protocolTitle: 'Protocole',
        protocol: [
          'Respiration 3–6–9 sur trois cycles complets.',
          'Identification d’une tension dominante.',
          'Visualisation d’un ennéagone intérieur.',
          'Localisation intuitive de la tension sur un point.',
          'Respiration dirigée vers ce point jusqu’à stabilisation.',
        ],
        research: {
          epsilon: 'ε faible (indication : 0,15–0,25)',
          canaux: 'Un canal + micro-corrections internes (régulation douce).',
          visee: 'Redistribution des excès, recentrage axial, cohérence interne.',
          modalites: ['Conscience', 'Adaptabilité', 'Décision'],
          trace: "Retour d’axe : tension moins dominante, clarté plus stable.",
        },
      },
      {
        id: 'med_rezonans_partagee',
        title: 'Méditation de la RéZonans partagée',
        subtitle: 'L’accord avec l’altérité',
        duration: '20 min',
        level: 'Avancé',
        desc:
          "Cette méditation prépare aux Accords. Elle développe la capacité à sentir sans absorption, à écouter sans projection, à tenir une présence stable face à l’autre.",
        protocolTitle: 'Protocole',
        protocol: [
          'Face à un partenaire, silence initial de trois minutes.',
          'Synchronisation respiratoire progressive.',
          'Perception des écarts vibratoires.',
          'Ajustement jusqu’à neutralité stable.',
          'Maintien du regard en présence consciente.',
        ],
        research: {
          epsilon: 'ε faible à modéré (indication : 0,2–0,4)',
          canaux: 'Deux canaux (soi / autre) : tenue sans domination ni effacement.',
          visee: 'Syntonie relationnelle, stabilité perceptive, passage sans capture.',
          modalites: ['Relation', 'Adaptabilité', 'Lucidité'],
          trace: "Relation tenue : présence plus vaste, réaction moins automatique.",
        },
      },
    ],

    accords: [
      {
        id: 'a01',
        code: 'A–01',
        title: 'Premier Accord',
        quote: '« Je m’accorde au temps que je vis, et je laisse tomber celui que j’anticipe. »',
        contexte: "Pour les moments d’anxiété anticipatoire.",
        rituel: 'À répéter à voix basse, trois fois.',
        research: {
          epsilon: 'ε moyen (indication : 0,4–0,6)',
          canaux: 'Multi-canaux (pensée / affect / orientation).',
          visee: 'Retour au temps vécu, réduction du futur imaginaire.',
          indicateur: 'Quand la pensée court devant l’expérience.',
        },
      },
      {
        id: 'a02',
        code: 'A–02',
        title: 'Deuxième Accord',
        quote: '« Ce qui résonne en moi demeure vivant. Ce qui s’est retiré laisse une trace active. »',
        contexte: 'Pour les moments de perte, de rupture ou de deuil.',
        rituel: 'En position assise, main posée sur le centre thoracique.',
        research: {
          epsilon: 'ε moyen (indication : 0,4–0,6)',
          canaux: 'Multi-canaux (mémoire / affect / présence).',
          visee: 'Tenir la trace sans se dissoudre dans l’absence.',
          indicateur: 'Quand le manque aspire toute l’attention.',
        },
      },
      {
        id: 'a03',
        code: 'A–03',
        title: 'Troisième Accord',
        quote: '« Je marche à la vitesse de ma résonance. »',
        contexte: 'Pour les moments de doute sur son chemin, comparaison, sentiment de retard.',
        rituel: 'À dire en marchant lentement, à chaque pas important.',
        research: {
          epsilon: 'ε moyen (indication : 0,4–0,6)',
          canaux: 'Multi-canaux (corps / orientation / décision).',
          visee: 'Récorder vitesse et direction, éviter la fuite en avant.',
          indicateur: 'Quand le mouvement sert à éviter de sentir.',
        },
      },
      {
        id: 'a04',
        code: 'A–04',
        title: 'Quatrième Accord',
        quote: '« L’accord juste tient maintenant. Il éclaire la décision sans la figer. »',
        contexte: 'Pour les décisions difficiles, les bifurcations.',
        rituel: 'À prononcer après un moment de silence, avant le choix.',
        research: {
          epsilon: 'ε moyen (indication : 0,4–0,6)',
          canaux: 'Multi-canaux (lucidité / décision / tenue).',
          visee: 'Décision orientée : fermeté légère, sans rigidification.',
          indicateur: 'Quand la perfection empêche l’acte.',
        },
      },
    ],

    researchBlocks: {
      title: 'Mode Chercheur',
      intro:
        "Ce complément ne prescrit pas : il oriente. Il propose une lecture opérative des pratiques (paramètres, seuils, Sceaux, modules situés).",

      sceauxTitle: 'Choisir une pratique selon le Sceau actif',
      sceauxLede:
        "Trois portes d’entrée : redistribution (Équiphase), réajustement (Syntonie), stabilisation du sentir (Aísthisi).",
      sceaux: [
        {
          seal: '619 — Équiphase',
          signature: 'Régime de redistribution',
          conseil:
            'Privilégier Δτ minimal ; pratiques courtes répétées ; relecture ; stabilisation.',
          assoc:
            'Accords conseillés : A–01 (temps vécu), A–04 (décision tenue).',
          indicateur: 'Si un excès de vitesse intérieure apparaît, rester sur ε faible.',
        },
        {
          seal: '593 — Syntonie',
          signature: 'Régime de réajustement',
          conseil:
            'Privilégier Isqun ; puis Accords : clarification des tensions, mise en commun.',
          assoc:
            'Accords conseillés : A–03 (vitesse juste), A–04 (accord juste).',
          indicateur: 'Si une friction relationnelle apparaît, passer par un Accord.',
        },
        {
          seal: '720 — Aísthisi',
          signature: 'Régime de sentir stabilisé',
          conseil:
            'Privilégier RéZonans partagée ; attention aux seuils sensoriels ; durée engagée.',
          assoc:
            'Accords conseillés : A–02 (trace vivante), A–03 (vitesse de résonance).',
          indicateur: 'Si le sentir déborde, ralentir et structurer la perception.',
        },
      ],

      lieuxTitle: 'Accord posœnnoïal du lieu',
      lieuxText:
        "Un lieu devient praticable quand il accorde. L’Accord du lieu correspond à un nœud de tenue : l’excédent se redistribue en seuil respirable. Lire un lieu consiste à sentir sa capacité à rendre habitable le passage.",
      lieuxProtoTitle: 'Micro-protocole',
      lieuxProto: [
        'Se placer immobile, sans chercher de signe.',
        'Percevoir le gradient : tension / détente / silence.',
        'Prononcer un Accord, puis écouter ce que le lieu renvoie.',
      ],

      dtTitle: 'Δτ et triade 3–6–9',
      dtText:
        "Δτ désigne un excédent à rendre habitable. La contrainte 3–6–9 sert de tenue : ouverture (3), accordage (6), redistribution (9).",
      dtApplyTitle: 'Application rapide',
      dtApply: [
        '3 respirations : entrée.',
        '6 respirations : stabilisation.',
        '9 respirations : diffusion.',
      ],
    },
  };

  /* -----------------------------
   * 2) CSS (injecté une seule fois)
   * ----------------------------- */
  var CSS = ''
    + '.po-pratiques, .po-pratiques *{ box-sizing:border-box; }'
    + '.po-pratiques{ color:#1d1b16; }'
    + '.po-pratiques__hero{ background: linear-gradient(180deg, #efece6 0%, #e8eef0 100%); padding: 56px 0 38px; }'
    + '.po-pratiques__body{ background:#f7f6f2; padding: 18px 0 56px; }'
    + '.po-wrap{ width:min(1060px, calc(100% - 48px)); margin:0 auto; }'
    + '.po-eyebrow{ font: 500 12px/1.2 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.18em; text-transform:uppercase; color:#6e6a61; margin:0 0 10px; }'
    + '.po-h1{ font: 500 64px/1.02 Georgia, "Times New Roman", serif; margin:0 0 12px; letter-spacing:.01em; }'
    + '.po-hero-rule{ width:34px; height:2px; background:#b08a2a; margin: 10px 0 18px; opacity:.95; }'
    + '.po-lede{ max-width: 760px; font: 400 14px/1.65 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#6f6a60; margin:0; }'

    + '.po-topbar{ display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-top: 18px; }'
    + '.po-research-cta{ display:flex; flex-direction:column; align-items:flex-end; gap:8px; }'
    + '.po-btn{ border:1px solid #d5d0c6; background:transparent; color:#6b665c; padding:10px 14px; border-radius:2px; cursor:pointer; font: 500 12px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.12em; text-transform:uppercase; }'
    + '.po-btn.is-on{ background:#a77712; border-color:#a77712; color:#fff; }'
    + '.po-btnhint{ max-width: 360px; text-align:right; font: 400 12px/1.45 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#7a7469; }'

    + '.po-section{ padding: 18px 0 0; }'
    + '.po-sec-eyebrow{ font: 500 11px/1.2 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.18em; text-transform:uppercase; color:#7a7469; margin: 0 0 8px; }'
    + '.po-sec-title{ font: 500 38px/1.06 Georgia, "Times New Roman", serif; margin:0 0 16px; }'
    + '.po-rule{ width: 26px; height: 2px; background:#b08a2a; opacity:.9; margin: 10px 0 18px; }'

    + '.po-med-list{ display:flex; flex-direction:column; gap:12px; }'
    + '.po-med{ border:1px solid #ddd8cf; background:#fbfaf7; }'
    + '.po-med-sum{ list-style:none; display:flex; align-items:center; justify-content:space-between; gap:18px; padding:18px 18px; cursor:pointer; }'
    + '.po-med-sum::-webkit-details-marker{ display:none; }'
    + '.po-med-left{ min-width:0; }'
    + '.po-med-title{ font: 500 22px/1.12 Georgia, "Times New Roman", serif; margin:0 0 6px; }'
    + '.po-med-sub{ font: 400 12px/1.35 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#7a7469; margin:0; }'
    + '.po-med-right{ display:flex; align-items:center; gap:10px; flex:0 0 auto; }'
    + '.po-chip{ border:1px solid #d8d3c9; background:#f5f3ee; color:#6b665c; padding:8px 10px; border-radius:2px; font: 500 11px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.06em; }'
    + '.po-med-panel{ border-top:1px solid #e3ded5; padding: 16px 18px 18px; }'
    + '.po-p{ font: 400 13px/1.85 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#5e594f; margin:0 0 12px; }'
    + '.po-h{ font: 600 11px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.22em; text-transform:uppercase; color:#7a7469; margin: 12px 0 10px; }'
    + '.po-ol{ margin: 0 0 10px 18px; padding:0; color:#5e594f; font: 400 13px/1.85 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; }'
    + '.po-ol li{ margin: 0 0 6px; }'

    + '.po-grid{ display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }'
    + '.po-acc{ border:1px solid #ddd8cf; background:#fbfaf7; }'
    + '.po-acc-sum{ list-style:none; padding: 18px 18px; cursor:pointer; }'
    + '.po-acc-sum::-webkit-details-marker{ display:none; }'
    + '.po-acc-code{ font: 600 11px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.22em; text-transform:uppercase; color:#b08a2a; margin: 0 0 10px; }'
    + '.po-acc-title{ font: 500 22px/1.12 Georgia, "Times New Roman", serif; margin: 0 0 10px; }'
    + '.po-acc-quote{ font: 400 13px/1.85 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#5e594f; margin: 0 0 10px; }'
    + '.po-acc-panel{ border-top:1px solid #e3ded5; padding: 14px 18px 18px; }'
    + '.po-small{ font: 400 12px/1.6 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#7a7469; margin:0 0 6px; }'

    + '.po-research{ margin-top: 22px; border:1px solid #ddd8cf; background:#fbfaf7; padding: 18px; display:none; }'
    + '.po-pratiques.is-research .po-research{ display:block; }'
    + '.po-research-title{ font: 500 28px/1.08 Georgia, "Times New Roman", serif; margin:0 0 10px; }'
    + '.po-research-intro{ font: 400 13px/1.85 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#5e594f; margin:0 0 12px; }'
    + '.po-research-grid{ display:grid; grid-template-columns: 1fr; gap: 14px; }'
    + '.po-card{ border:1px solid #e3ded5; background:#fdfcf9; padding: 14px 14px 12px; }'
    + '.po-card-title{ font: 600 11px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.22em; text-transform:uppercase; color:#7a7469; margin:0 0 10px; }'
    + '.po-card-p{ font: 400 13px/1.85 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#5e594f; margin:0; }'
    + '.po-research-inline{ display:none; margin-top: 12px; padding-top: 12px; border-top: 1px dashed #e3ded5; }'
    + '.po-pratiques.is-research .po-research-inline{ display:block; }'
    + '.po-kv{ display:grid; grid-template-columns: 140px 1fr; gap: 8px 14px; }'
    + '.po-k{ font: 600 11px/1.2 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; letter-spacing:.18em; text-transform:uppercase; color:#7a7469; }'
    + '.po-v{ font: 400 13px/1.75 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#5e594f; }'
    + '.po-tags{ display:flex; flex-wrap:wrap; gap:8px; margin-top: 10px; }'
    + '.po-tag{ border:1px solid #d8d3c9; background:#f5f3ee; color:#6b665c; padding:7px 9px; border-radius:999px; font: 500 11px/1 system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; }'

    + '@media (max-width: 880px){ .po-h1{ font-size:48px; } }'
    + '@media (max-width: 720px){ .po-grid{ grid-template-columns: 1fr; } .po-topbar{ flex-direction:column; align-items:flex-start; } .po-research-cta{ align-items:flex-start; } .po-btnhint{ text-align:left; } }'
    + '@media (max-width: 520px){ .po-wrap{ width: calc(100% - 28px); } .po-h1{ font-size:42px; } .po-med-sum, .po-acc-sum{ padding: 16px 14px; } .po-med-panel, .po-acc-panel{ padding: 14px 14px 16px; } }';

  function injectCSS() {
    if (document.getElementById('po-pratiques-style')) return;
    var style = document.createElement('style');
    style.id = 'po-pratiques-style';
    style.type = 'text/css';
    style.appendChild(document.createTextNode(CSS));
    document.head.appendChild(style);
  }

  /* -----------------------------
   * 3) DOM helpers (ES5)
   * ----------------------------- */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!attrs.hasOwnProperty(k)) continue;
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      }
    }
    if (children && children.length) {
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (!c) continue;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      }
    }
    return node;
  }

  function setLSBool(key, val) {
    try { localStorage.setItem(key, val ? '1' : '0'); } catch (e) {}
  }
  function getLSBool(key) {
    try { return localStorage.getItem(key) === '1'; } catch (e) {}
    return false;
  }

  /* -----------------------------
   * 4) Render blocks
   * ----------------------------- */
  function renderHero() {
    var hint = el('div', { class: 'po-btnhint', text: DATA.page.ctaResearchHint });

    var btn = el('button', {
      class: 'po-btn',
      type: 'button',
      'data-po-research-toggle': '',
      'aria-pressed': 'false',
      text: DATA.page.ctaResearch,
    });

    var cta = el('div', { class: 'po-research-cta' }, [btn, hint]);

    var topbar = el('div', { class: 'po-topbar' }, [
      el('div', { class: 'po-topbar__left' }),
      cta,
    ]);

    return el('div', { class: 'po-pratiques__hero' }, [
      el('div', { class: 'po-wrap' }, [
        el('div', { class: 'po-eyebrow', text: DATA.page.eyebrow }),
        el('h1', { class: 'po-h1', text: DATA.page.h1 }),
        el('div', { class: 'po-hero-rule', 'aria-hidden': 'true' }),
        el('p', { class: 'po-lede', text: DATA.page.lede }),
        topbar,
      ]),
    ]);
  }

  function renderMeditations(root) {
    root.appendChild(el('div', { class: 'po-sec-eyebrow', text: DATA.meditationsTitleEyebrow }));
    root.appendChild(el('div', { class: 'po-sec-title', text: DATA.meditationsTitle }));
    root.appendChild(el('div', { class: 'po-rule', 'aria-hidden': 'true' }));

    var list = el('div', { class: 'po-med-list', 'data-po-med-list': '' });

    for (var i = 0; i < DATA.meditations.length; i++) {
      var m = DATA.meditations[i];

      var left = el('div', { class: 'po-med-left' }, [
        el('div', { class: 'po-med-title', text: m.title }),
        el('p', { class: 'po-med-sub', text: m.subtitle }),
      ]);

      var right = el('div', { class: 'po-med-right' }, [
        el('span', { class: 'po-chip', text: m.duration }),
        el('span', { class: 'po-chip', text: m.level }),
      ]);

      var summary = el('summary', { class: 'po-med-sum' }, [left, right]);

      var panel = el('div', { class: 'po-med-panel' }, [
        el('p', { class: 'po-p', text: m.desc }),
        el('div', { class: 'po-h', text: m.protocolTitle }),
        makeProtocolOl(m.protocol),
        makeResearchInline(m.research),
      ]);

      var details = el('details', { class: 'po-med', 'data-po-kind': 'meditation', 'data-po-id': m.id }, [
        summary,
        panel,
      ]);

      list.appendChild(details);
    }

    root.appendChild(list);
  }

  function renderAccords(root) {
    root.appendChild(el('div', { class: 'po-sec-eyebrow', text: DATA.accordsTitleEyebrow }));
    root.appendChild(el('div', { class: 'po-sec-title', text: DATA.accordsTitle }));
    root.appendChild(el('div', { class: 'po-rule', 'aria-hidden': 'true' }));
    root.appendChild(el('p', { class: 'po-lede', text: DATA.accordsIntro }));

    var grid = el('div', { class: 'po-grid', 'data-po-acc-grid': '' });

    for (var i = 0; i < DATA.accords.length; i++) {
      var a = DATA.accords[i];

      var sum = el('summary', { class: 'po-acc-sum' }, [
        el('div', { class: 'po-acc-code', text: a.code }),
        el('div', { class: 'po-acc-title', text: a.title }),
        el('div', { class: 'po-acc-quote', text: a.quote }),
      ]);

      var panel = el('div', { class: 'po-acc-panel' }, [
        el('div', { class: 'po-small', text: 'Contexte : ' + a.contexte }),
        el('div', { class: 'po-small', text: 'Rituel : ' + a.rituel }),
        makeResearchInline(a.research),
      ]);

      var details = el('details', { class: 'po-acc', 'data-po-kind': 'accord', 'data-po-id': a.id }, [
        sum,
        panel,
      ]);

      grid.appendChild(details);
    }

    root.appendChild(grid);
  }

  function makeProtocolOl(list) {
    var ol = el('ol', { class: 'po-ol' });
    for (var i = 0; i < list.length; i++) {
      ol.appendChild(el('li', { text: list[i] }));
    }
    return ol;
  }

  function makeResearchInline(r) {
    if (!r) return null;

    var kv = el('div', { class: 'po-kv' }, [
      el('div', { class: 'po-k', text: 'Mesure' }),
      el('div', { class: 'po-v', text: r.epsilon || '' }),

      el('div', { class: 'po-k', text: 'Canaux' }),
      el('div', { class: 'po-v', text: r.canaux || '' }),

      el('div', { class: 'po-k', text: 'Visée' }),
      el('div', { class: 'po-v', text: r.visee || '' }),
    ]);

    var more = [];
    if (r.indicateur) {
      more.push(el('div', { class: 'po-k', text: 'Indicateur' }));
      more.push(el('div', { class: 'po-v', text: r.indicateur }));
    }
    if (r.trace) {
      more.push(el('div', { class: 'po-k', text: 'Trace' }));
      more.push(el('div', { class: 'po-v', text: r.trace }));
    }

    var tags = null;
    if (r.modalites && r.modalites.length) {
      tags = el('div', { class: 'po-tags' });
      for (var i = 0; i < r.modalites.length; i++) {
        tags.appendChild(el('span', { class: 'po-tag', text: r.modalites[i] }));
      }
    }

    var inline = el('div', { class: 'po-research-inline', 'data-po-research-inline': '' }, [
      el('div', { class: 'po-h', text: 'Paramètres (Chercheur)' }),
      kv,
    ]);

    // Ajouts optionnels (indicateur / trace)
    if (more.length) {
      var kv2 = el('div', { class: 'po-kv' }, more);
      inline.appendChild(kv2);
    }
    if (tags) inline.appendChild(tags);

    return inline;
  }

  function renderResearchBlocks(root) {
    var R = DATA.researchBlocks;

    var section = el('section', { class: 'po-research', 'data-po-research': '' }, [
      el('div', { class: 'po-research-title', text: R.title }),
      el('p', { class: 'po-research-intro', text: R.intro }),

      // Sceaux
      el('div', { class: 'po-card' }, [
        el('div', { class: 'po-card-title', text: R.sceauxTitle }),
        el('p', { class: 'po-card-p', text: R.sceauxLede }),
      ]),
    ]);

    // Cartes Sceaux
    var sceauxWrap = el('div', { class: 'po-research-grid' });
    for (var i = 0; i < R.sceaux.length; i++) {
      var s = R.sceaux[i];
      sceauxWrap.appendChild(
        el('div', { class: 'po-card' }, [
          el('div', { class: 'po-card-title', text: s.seal + ' — ' + s.signature }),
          el('p', { class: 'po-card-p', text: s.conseil }),
          el('p', { class: 'po-card-p', text: s.assoc }),
          el('p', { class: 'po-card-p', text: 'Indicateur : ' + s.indicateur }),
        ])
      );
    }
    section.appendChild(sceauxWrap);

    // Accord du lieu
    section.appendChild(
      el('div', { class: 'po-card' }, [
        el('div', { class: 'po-card-title', text: R.lieuxTitle }),
        el('p', { class: 'po-card-p', text: R.lieuxText }),
        el('div', { class: 'po-h', text: R.lieuxProtoTitle }),
        makeProtocolOl(R.lieuxProto),
      ])
    );

    // Δτ / 3–6–9
    section.appendChild(
      el('div', { class: 'po-card' }, [
        el('div', { class: 'po-card-title', text: R.dtTitle }),
        el('p', { class: 'po-card-p', text: R.dtText }),
        el('div', { class: 'po-h', text: R.dtApplyTitle }),
        makeProtocolOl(R.dtApply),
      ])
    );

    root.appendChild(section);
  }

  function render(root) {
    var hero = renderHero();

    var body = el('div', { class: 'po-pratiques__body' }, [
      el('div', { class: 'po-wrap' }, [
        el('section', { class: 'po-section', 'data-po-sec': 'meditations' }, []),
        el('section', { class: 'po-section', 'data-po-sec': 'accords' }, []),
      ]),
    ]);

    var wrapper = el('section', { class: 'po-pratiques', 'data-po-pratiques': '' }, [hero, body]);

    root.innerHTML = '';
    root.appendChild(wrapper);

    // Inject sections content
    var medSec = wrapper.querySelector('[data-po-sec="meditations"]');
    var accSec = wrapper.querySelector('[data-po-sec="accords"]');

    renderMeditations(medSec);
    renderAccords(accSec);

    // Research blocks (bas de page, mais uniquement visible en mode chercheur)
    var wrap = wrapper.querySelector('.po-wrap');
    renderResearchBlocks(wrap);

    wireBehaviors(wrapper);
  }

  /* -----------------------------
   * 5) Behaviors
   * ----------------------------- */
  function wireBehaviors(root) {
    // Toggle mode chercheur
    var btn = root.querySelector('[data-po-research-toggle]');
    function setResearch(on) {
      root.classList.toggle('is-research', !!on);
      if (btn) {
        btn.classList.toggle('is-on', !!on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      setLSBool(LS_KEY, !!on);
    }

    var initial = FORCE_RESEARCH ? true : getLSBool(LS_KEY);
    setResearch(initial);

    if (btn) {
      btn.addEventListener('click', function () {
        setResearch(!root.classList.contains('is-research'));
      });
    }

    // Accordéon doux : 1 item ouvert à la fois par bloc
    function wireAccordion(containerSelector) {
      var container = root.querySelector(containerSelector);
      if (!container) return;
      container.addEventListener(
        'toggle',
        function (e) {
          var t = e.target;
          if (!t || t.tagName !== 'DETAILS') return;
          if (!t.open) return;

          // ferme les autres
          var all = container.querySelectorAll('details');
          for (var i = 0; i < all.length; i++) {
            if (all[i] !== t) all[i].removeAttribute('open');
          }
        },
        true
      );
    }

    wireAccordion('[data-po-med-list]');
    wireAccordion('[data-po-acc-grid]');
  }

  /* -----------------------------
   * 6) BOOT
   * ----------------------------- */
  function boot() {
    injectCSS();

    var mount = document.querySelector(mountSelector);
    if (!mount) {
      mount = document.createElement('div');
      mount.id = 'po-pratiques-mount';
      document.body.appendChild(mount);
    }
    render(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();